<template>
  <div>
    <span>{{ hmsStr }}</span>
  </div>
</template>

<script>
export default {
  props: {
    endTime: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      countdown: 0,
      day: '',
      hour: '',
      min: '',
      second: '',

      hmsStr: "",
    };
  },
  computed: {
    remainingTime() {
      console.log("值的交流空间");
      // return this.endTime / 1000 - Math.floor(Date.now() / 1000)
    },
  },
  mounted() {
    // console.log("走进了");
    this.countdown = this.endTime / 1000 - Math.floor(Date.now() / 1000);
    setInterval(() => {
      this.countdown = this.endTime / 1000 - Math.floor(Date.now() / 1000);
      this.changeValue(this.countdown);
    }, 1000);
  },
  methods: {
    changeValue(leftCount) {
      
      if (leftCount >= 0) {
        // 天
        this.day = Math.floor(leftCount / 60 / 60 / 24);
        // 时
        let h = Math.floor((leftCount / 60 / 60) % 24);
        this.hour = h < 10 ? "0" + h : h;
        // 分
        let m = Math.floor((leftCount / 60) % 60);
        this.min = m < 10 ? "0" + m : m;
        // 秒
        let s = Math.floor(leftCount % 60);
        this.second = s < 10 ? "0" + s : s;

        let str =
          this.hour +
          ":" +
          this.min +
          ":" +
          this.second +
          "";
        //将字符串显示在div中
        this.hmsStr = str;
      } else {
        this.day = 0;
        this.hour = "00";
        this.min = "00";
        this.second = "00";

        let str =
          this.hour +
          ":" +
          this.min +
          ":" +
          this.second +
          "";
        //将字符串显示在div中
        this.hmsStr = str;
      }
    },
  },
};
</script>
